<script>
  import { GQLNow } from "gql-now";
  import { onMount } from "svelte";
  import { BASE_URL } from "../services/service.config";
  import { PKClient } from "../services/PKClient";
  import {
    App,
    f7,
    f7ready,
    Card,
    CardFooter,
    CardContent,
    CardHeader,
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    Row,
    Col,
    Button,
    Gauge,
    AreaChart,
    Panel,
    Menu,
    MenuItem,
    MenuDropdown,
    MenuDropdownItem,
    Icon,
    Searchbar,
    Badge,
    AccordionContent,
  } from "framework7-svelte";
  export let f7router;
  export let f7route;
  let user_data = [],
    admin_access_token,
    toast_success,
    toast_error;
  onMount(() => {
    f7ready(async () => {
      admin_access_token = localStorage.getItem("token");
      await fetch_all_user_details();
    });
  });
  const showToastSuccess = (r) => {
    // Create toast
    if (!toast_success) {
      toast_success = f7.toast.create({
        text: `Success: ${r.withdraw_status}:${r._id} - INR ${r.processed_amount || ""}`,
        position: "center",
        closeButton: true,
        closeButtonText: "Okay",
        closeButtonColor: "green",
      });
    }
    // Open it
    toast_success.open();
  };
  const showToastError = () => {
    // Create toast
    if (!toast_error) {
      toast_error = f7.toast.create({
        text: `Error: Refresh page. Check the status before trying again.`,
        position: "center",
        closeButton: true,
        closeButtonText: "Okay",
        closeButtonColor: "red",
      });
    }
    // Open it
    toast_error.open();
  };

  async function update_withdraw_status(data) {
    let payload = {
      transaction_id: data._id,
      withdraw_status: data.withdraw_status,
      processed_amount: data.processed_amount,
    };
    //console.log("payload",payload)
    let obj = new GQLNow(`https://api.trdr.money/graphql/trdr-admin-services`, {
      "x-trdr-org": "60e6cd9df9c32f00072b71f8",
      "x-access-token": admin_access_token,
    });
    try {
      f7.preloader.show();
      let response = await obj.mutation(
        "update_withdraw_request",
        payload,
        "_id withdraw_amount withdraw_status processed_amount txTime modified_ts"
      );
      f7.preloader.hide();
      showToastSuccess(response.data.update_withdraw_request);
      return response.data.update_withdraw_request;
      // f7router.navigate(`/thankyou/`);
    } catch (err) {
      // f7router.navigate(`/admin-login-otp/`);
      f7.preloader.hide();
      showToastError();
      throw err;
    }
  }
  const fetch_all_user_details = async () => {
    let obj = new GQLNow(`https://api.trdr.money/graphql/trdr-admin-services`, {
      "x-trdr-org": "60e6cd9df9c32f00072b71f8",
      "x-access-token": admin_access_token,
    });
    try {
      console.log("calling cashfree api...");
      let response = await obj.query(
        "get_all_withdraw_requests",
        {},
        "withdraw_requests {_id ucc full_name withdraw_amount txTime modified_ts withdraw_status processed_amount}"
      );
      console.log("\n\n Cashfree Data:", response);
      user_data = response.data.get_all_withdraw_requests.withdraw_requests;
      var filtered = user_data.filter(function (el) {
        // return el != null;
        var propNames = Object.getOwnPropertyNames(el);
        for (var i = 0; i < propNames.length; i++) {
          var propName = propNames[i];
          if (el[propName] === null || el[propName] === undefined) {
            el[propName] = "";
          }
        }
      });
      // console.log({ user_data });
      // localStorage.setItem("Cashfree Data", JSON.stringify(user_data));
    } catch (err) {
      console.log({ gen_otp_error: err });
      f7.dialog.alert(err);
    }
  };

  function convert_date(timestamp) {
    let t = parseInt(timestamp);
    var d = new Date(t);
    let final_date =
      d.getDate() +
      "/" +
      (d.getMonth() + 1) +
      "/" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();

    return final_date;
  }
</script>

<Page class="admin-home">
  <Navbar>
    <NavLeft>
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-left"
      />
    </NavLeft>

    <NavRight>
      <Link>
        <p class="title-text">URL:desk.trdr.money</p>
      </Link>
      <Link iconOnly>
        <Icon ios="f7:bell_fill" aurora="f7:bell_fill" md="f7:bell_fill">
          <Badge color="blue">5</Badge>
        </Icon>
      </Link>
      <Link
        iconIos="f7:question_circle"
        iconAurora="f7:question_circle"
        iconMd="f7:question_circle"
      />
      <Link
        iconIos="f7:person_alt_circle"
        iconAurora="f7:person_alt_circle"
        iconMd="f7:person_alt_circle"
      />
      <!-- <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-right"
      /> -->
    </NavRight>

    <!-- <NavTitle>User Details</NavTitle> -->
  </Navbar>

  <div class="page-content padding">
    <BlockTitle large class="padding-left padding-top"
      >Withdraw Requests</BlockTitle
    >
    <Block>
      <div class="card data-table hoverTable">
        <table>
          <thead>
            <tr>
              <th class="label-cell">No.</th>
              <th>Transaction ID</th>
              <th>UCC</th>
              <th>Name</th>
              <th>Amount</th>
              <th>Txn Time</th>
              <th>Modified</th>
              <th>Status</th>
              <th>Processed Amt</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {#each user_data as user, i}
              <tr>
                <td>{i + 1}</td>
                <td
                  ><input
                    type="hidden"
                    id="transaction_id"
                    name="transaction_id"
                    style=""
                    value={user._id}
                  />{user._id}</td
                >
                <td>{user.ucc}</td>
                <td>{user.full_name}</td>
                <td>{user.withdraw_amount}</td>
                <td>{user.txTime}</td>
                <td>{user.modified_ts}</td>
                <td>
                  <select
                    id="withdraw_status"
                    name="withdraw_status"
                    bind:value={user.withdraw_status}
                    style="padding: 5px; color:black; background-color:#C4C3C3; border-radius:10px"
                  >
                    {#if user.withdraw_status === "processed"}
                      <option value={user.withdraw_status}
                        >{user.withdraw_status} &#9660;</option
                      >
                      <option value="pending">Pending</option>
                      <option value="cancelled">Cancelled</option>
                    {:else if user.withdraw_status === "cancelled"}
                      <option value={user.withdraw_status}
                        >{user.withdraw_status} &#9660;</option
                      >
                      <option value="pending">Pending</option>
                      <option value="processed">Processed</option>
                    {:else}
                      <option value={user.withdraw_status || "pending"}
                        >{user.withdraw_status || "pending"} &#9660;</option
                      >
                      <option value="processed">Processed</option>
                      <option value="cancelled">Cancelled</option>
                    {/if}
                  </select>
                </td>
                <td
                  ><input
                    type="text"
                    id="processed_amount"
                    name="processed_amount"
                    style="border-radius: 5px;
                    background-color: #f2f2f2;
                    padding: 10px;
                    width:70%;
                    color:black"
                    bind:value={user.processed_amount}
                  /></td
                >
                <td>
                  <input
                    style="
                    background-color: #4CAF50;
                    border: none;
                    border-radius: 12px;
                    color: white;
                    padding: 10px;
                    text-align: center;
                    text-decoration: none;
                    display: inline-block;
                    cursor: pointer;
                    "
                    value="Save"
                    on:click={()=>{update_withdraw_status(user)}}
                  />
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
        <!-- <div class="data-table-footer">
          <div class="data-table-rows-select">
            Per page:
            <div class="input input-dropdown">
              <select>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="all">All</option>
              </select>
            </div>
          </div>
          <div class="data-table-pagination">
            <span class="data-table-pagination-label">1-5 of 10</span>
            <a href="#" class="link disabled">
              <i class="icon icon-prev color-gray" />
            </a>
            <a href="#" class="link">
              <i class="icon icon-next color-gray" />
            </a>
          </div>
        </div> -->
      </div>
    </Block>
  </div>
</Page>

<style>
  :global(.demo-card-header-pic .card-header) {
    height: 40vw;
    background-size: cover;
    background-position: center;
    color: #fff;
  }
  :global(.demo-card-header-pic .card-content-padding .date) {
    color: #8e8e93;
  }
  :global(.title-text) {
    position: relative;
    overflow: hidden;
    margin: 0;
    white-space: var(--f7-block-title-white-space);
    text-overflow: ellipsis;
    text-transform: var(--f7-block-title-text-transform);
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size, inherit);
    font-weight: var(--f7-block-title-font-weight);
    line-height: var(--f7-block-title-line-height);
  }
  .hoverTable {
    width: 100%;
    border-collapse: collapse;
  }
  .hoverTable th {
    background-color: #000;
    color: #fff;
  }
  .hoverTable tr:hover {
    background-color: rgb(52, 51, 51);
    color: #fff;
  }
</style>
